import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import AdvancedReports from "./index";
import { MODULE_REPORTS } from "variables/constants";
import ViewAdvancedReport from "./view";

const advancedReportRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Generate Report",
        basePath: "generate-report",
        mainComponent: <AdvancedReports/>,
        layout: "/console",
        subTitle:"Generate Report",
        viewComponent: <ViewAdvancedReport />,
        level:4,
        moduleId: MODULE_REPORTS,
    })
]

export default advancedReportRoutes;